import { CheckIcon } from '@heroicons/react/24/solid'
import { classNames } from '../tools/ClassNames'

const StepSidebarAdmin = ({ pasosSidebar = [{}] }) => {
    return (
        <dl className="mt-5 p-4 fixed top-1/4 right-14 h-128 w-64 rounded bg-secundarioMira || hidden xl:block" id="pasos-sidebar ipad">
            <nav aria-label="Progress">
                <ol role="list" className="overflow-hidden">
                    {pasosSidebar.map((step, stepIdx) => (
                        <li key={step.name} className={classNames(stepIdx !== pasosSidebar.length - 1 ? 'pb-10' : '', 'relative')}>
                            {step.status === 'complete' ? (
                                <>
                                    {stepIdx !== pasosSidebar.length - 1 ? (
                                        <div className="absolute top-4 left-4 -ml-px mt-0.5 h-full w-0.5 bg-azulBrillanteMira " aria-hidden="true" />
                                    ) : null}
                                    <a href={step.href} className="group relative flex items-start">
                                        <span className="flex h-9 items-center">
                                            <span className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full bg-azulBrillanteMira group-hover:bg-azulLogos">
                                                <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                            </span>
                                        </span>
                                        <span className="ml-4 flex min-w-0 flex-col">
                                            <span className="text-sm font-medium text-azulBrillanteMira group-hover:bg-azulLogos">{step.name}</span>
                                            <span className="text-sm text-grisMira">{step.description}</span>
                                        </span>
                                    </a>
                                </>
                            ) : step.status === 'current' ? (
                                <>
                                    {stepIdx !== pasosSidebar.length - 1 ? (
                                        <div className="absolute top-4 left-4 -ml-px mt-0.5 h-full w-0.5 bg-grisMira" aria-hidden="true" />
                                    ) : null}
                                    <a href={step.href} className="group relative flex items-start" aria-current="step">
                                        <span className="flex h-9 items-center" aria-hidden="true">
                                            <span className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-secundario bg-white">
                                                <span className="h-2.5 w-2.5 rounded-full bg-secundario" />
                                            </span>
                                        </span>
                                        <span className="ml-4 flex min-w-0 flex-col">
                                            <span className="text-sm font-medium text-secundario">{step.name}</span>
                                            <span className="text-sm text-grisMira">{step.description}</span>
                                        </span>
                                    </a>
                                </>
                            ) : (
                                <>
                                    {stepIdx !== pasosSidebar.length - 1 ? (
                                        <div className="absolute top-4 left-4 -ml-px mt-0.5 h-full w-0.5 bg-grisMira" aria-hidden="true" />
                                    ) : null}
                                    <a href={step.href} className="group relative flex items-start">
                                        <span className="flex h-9 items-center" aria-hidden="true">
                                            <span className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-grisMira bg-white group-hover:border-grisMira">
                                                <span className="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-grisMira" />
                                            </span>
                                        </span>
                                        <span className="ml-4 flex min-w-0 flex-col">
                                            <span className="text-sm font-medium text-grisMira">{step.name}</span>
                                            <span className="text-sm text-grisMira">{step.description}</span>
                                        </span>
                                    </a>
                                </>
                            )}
                        </li>
                    ))}
                </ol>
            </nav>
        </dl>
    )
}

export default StepSidebarAdmin